import { Phone, Mail } from "lucide-react";
import { Reveal, Tag, Heading } from "../Reveal";

const POINTS = [
  "100+ combined rehab & abatement projects",
  "HUD, municipal & community-based experience",
  "Operates as General Contractor or Subcontractor",
  "DBE Certified · Lead Abatement Firm Certified",
];

export const Proprietor = () => (
  <section id="proprietor" className="py-24 lg:py-40 bg-ink text-bone" data-testid="proprietor-section">
    <div className="mx-auto max-w-[1600px] px-5 sm:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
      <Reveal className="lg:col-span-5">
        <div className="relative">
          <img src="/images/home/trevor.jpg" alt="Trevor Blyden, Proprietor of Construction Alliance LLC" className="w-full aspect-square object-cover" data-testid="proprietor-headshot" />
          <div className="absolute bottom-0 left-0 bg-bone text-ink px-6 py-5">
            <p className="font-display font-semibold text-2xl tracking-[-0.015em] leading-none" data-testid="proprietor-name">Trevor Blyden</p>
            <p className="mt-2 font-mono text-[10px] uppercase tracking-[0.18em] text-ink/55">Proprietor · Construction Alliance LLC</p>
          </div>
        </div>
      </Reveal>
      <Reveal className="lg:col-span-6 lg:col-start-7" delay={0.1}>
        <Tag light>Meet the proprietor</Tag>
        <Heading light className="mt-6">A builder who answers the phone.</Heading>
        <p className="mt-8 text-base sm:text-lg text-bone/65 leading-relaxed max-w-lg">
          Trevor leads every Construction Alliance project personally — from municipal gut rehabs and HUD housing to the kitchen down the street. Honest communication, code compliance, safety and quality delivery aren't slogans here; they're how the work gets done.
        </p>
        <ul className="mt-8 divide-y divide-bone/15 border-y border-bone/15">
          {POINTS.map((p) => (
            <li key={p} className="py-3.5 font-display font-medium text-lg text-bone">{p}</li>
          ))}
        </ul>
        <div className="mt-8 flex flex-wrap gap-x-8 gap-y-3">
          <a href="tel:3022301988" data-testid="proprietor-phone-link" className="inline-flex items-center gap-2.5 font-display font-medium text-lg text-bone hover:text-teal transition-colors">
            <Phone className="h-4 w-4 text-teal" /> 302.230.1988
          </a>
          <a href="mailto:TBlyden@ConstructionAllianceCo.com" data-testid="proprietor-email-link" className="inline-flex items-center gap-2.5 font-display font-medium text-base sm:text-lg text-bone hover:text-teal transition-colors">
            <Mail className="h-4 w-4 text-teal" /> TBlyden@ConstructionAllianceCo.com
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
